import { EducatorPageChrome } from "@/pages/educators/page-chrome"
import { useId } from "react"

import { PageBody } from "@/components/ui/layout"
import { SaveButton } from "@/components/shared/action-buttons"

import ListingProfileForm from "./form"
import { EducatorsListingProfilesTeamListingProfileForm } from "@/types/serializers"
import { useNavigate } from "@/lib/page-rendering"

export default function New() {
  const navigate = useNavigate()
  const formId = useId()
  const titleId = useId()
  const onSubmit = (data: {
    listing_profile: EducatorsListingProfilesTeamListingProfileForm
  }) => {
    navigate({
      href: ".",
      method: "post",
      data: data,
    })
  }

  return (
    <>
      <EducatorPageChrome
        titleId={titleId}
        action={<SaveButton form={formId} />}
      />
      <PageBody>
        <ListingProfileForm
          formId={formId}
          titleId={titleId}
          onSubmit={onSubmit}
        />
      </PageBody>
    </>
  )
}
